import React from 'react';

const DISCUSSION_TYPES_MAP = {
  research_paper:       { label: 'Research Paper',       emoji: '🔬', badge: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
  news:                 { label: 'News',                 emoji: '📰', badge: 'bg-blue-50 text-blue-700 border-blue-200' },
  clinical_observation: { label: 'Clinical Observation', emoji: '💬', badge: 'bg-purple-50 text-purple-700 border-purple-200' },
  my_research:          { label: 'My Research',          emoji: '📝', badge: 'bg-amber-50 text-amber-700 border-amber-200' },
};

const CaseBody = ({ title, description, hashtags = [], postType, discussionType }) => {
  const isQuickDiscussion = postType === 'quick_discussion';
  const typeInfo = discussionType && DISCUSSION_TYPES_MAP[discussionType];

  return (
    <div className="mt-3 space-y-2.5">
      {/* Discussion Type Badge (Quick Discussion) */}
      {isQuickDiscussion && typeInfo && (
        <div className="flex items-center gap-2">
          <span className={`text-xs px-2.5 py-0.5 rounded-full font-semibold border ${typeInfo.badge}`}>
            {typeInfo.emoji} {typeInfo.label}
          </span>
        </div>
      )}

      {/* Title */}
      {title && (
        <h3 className="text-base font-semibold text-text-black leading-snug break-words [overflow-wrap:anywhere]">{title}</h3>
      )}

      {/* Description / Content */}
      <p className="text-sm text-gray-600 leading-relaxed line-clamp-3 break-words [overflow-wrap:anywhere]">
        {description ? description.replace(/<[^>]+>/g, ' ').trim() : ''}
      </p>

      {/* Hashtags */}
      {hashtags.length > 0 && (
        <div className="flex items-center gap-1.5 pt-1 flex-wrap">
          {hashtags.map((tag) => (
            <span
              key={tag}
              className="text-xs text-indigo-600 bg-indigo-50/70 px-2 py-0.5 rounded-lg border border-indigo-100
                         hover:bg-indigo-100 cursor-pointer transition-colors duration-200"
            >
              #{tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default CaseBody;